import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { Button } from './ui/button';
import { Phone, ArrowRight, X, ChevronLeft, ChevronRight } from 'lucide-react';

export const GalleryPage = () => {
  const { t, language } = useLanguage();
  const [selectedAlbum, setSelectedAlbum] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Albums with cover images and gallery images
  const albums = [
    {
      id: 'kuca-kljuc-u-ruke',
      title: 'Kuća - ključ u ruke',
      coverImage: "https://customer-assets.emergentagent.com/job_rade-gradnja/artifacts/vhdqubsi_347637.jpg",
      images: [
        { url: "https://customer-assets.emergentagent.com/job_rade-gradnja/artifacts/5s159r52_1.jpg", title: "Kuća - ključ u ruke" },
        { url: "https://customer-assets.emergentagent.com/job_rade-gradnja/artifacts/kstjv2u0_2.jpg", title: "Kuća - ključ u ruke" },
        { url: "https://customer-assets.emergentagent.com/job_rade-gradnja/artifacts/qsgcbaol_3.jpg", title: "Kuća - ključ u ruke" },
        { url: "https://customer-assets.emergentagent.com/job_rade-gradnja/artifacts/eigt5oug_4.jpg", title: "Kuća - ključ u ruke" },
        { url: "https://customer-assets.emergentagent.com/job_rade-gradnja/artifacts/d537mwty_5.jpg", title: "Kuća - ključ u ruke" }
      ]
    },
    {
      id: 'privatni-bazen',
      title: 'Privatni bazen',
      coverImage: "https://images.pexels.com/photos/261327/pexels-photo-261327.jpeg?auto=compress&cs=tinysrgb&w=800",
      images: [
        { url: "https://customer-assets.emergentagent.com/job_rade-gradnja/artifacts/pvbtolo2_1.jpg", title: "Privatni bazen" },
        { url: "https://customer-assets.emergentagent.com/job_rade-gradnja/artifacts/cw7jjfp9_2.jpg", title: "Privatni bazen" },
        { url: "https://customer-assets.emergentagent.com/job_rade-gradnja/artifacts/rcjgye8u_3.jpg", title: "Privatni bazen" },
        { url: "https://customer-assets.emergentagent.com/job_rade-gradnja/artifacts/0y4hjddx_4.jpg", title: "Privatni bazen" }
      ]
    },
    {
      id: 'moderna-garaza',
      title: 'Moderna garaža',
      coverImage: "https://images.pexels.com/photos/20548104/pexels-photo-20548104.jpeg?auto=compress&cs=tinysrgb&w=800",
      images: [
        { url: "https://customer-assets.emergentagent.com/job_rade-gradnja/artifacts/7l1743no_1.jpg", title: "Moderna garaža" },
        { url: "https://customer-assets.emergentagent.com/job_rade-gradnja/artifacts/f7ybu0k2_2.jpg", title: "Moderna garaža" },
        { url: "https://customer-assets.emergentagent.com/job_rade-gradnja/artifacts/l1zpwg9e_3.jpg", title: "Moderna garaža" },
        { url: "https://customer-assets.emergentagent.com/job_rade-gradnja/artifacts/go6kwk68_4.jpg", title: "Moderna garaža" },
        { url: "https://customer-assets.emergentagent.com/job_rade-gradnja/artifacts/nqyigz8h_5.jpg", title: "Moderna garaža" },
        { url: "https://customer-assets.emergentagent.com/job_rade-gradnja/artifacts/b7mhycfl_6.jpg", title: "Moderna garaža" }
      ]
    },
    {
      id: 'retro-letnjikovac',
      title: 'Retro letnjikovac',
      coverImage: "https://images.pexels.com/photos/7212850/pexels-photo-7212850.jpeg?auto=compress&cs=tinysrgb&w=800",
      images: [
        { url: "https://customer-assets.emergentagent.com/job_rade-gradnja/artifacts/fi7dr0i6_1.jpg", title: "Retro letnjikovac" },
        { url: "https://customer-assets.emergentagent.com/job_rade-gradnja/artifacts/bhuk747v_2.jpg", title: "Retro letnjikovac" },
        { url: "https://customer-assets.emergentagent.com/job_rade-gradnja/artifacts/xujiwgdf_3.jpg", title: "Retro letnjikovac" }
      ]
    },
    {
      id: 'zamena-crepa',
      title: 'Zamena crepa',
      coverImage: "https://images.unsplash.com/photo-1681049400158-0ff6249ac315?crop=entropy&cs=srgb&fm=jpg&w=800&q=85",
      images: [
        { url: "https://customer-assets.emergentagent.com/job_rade-gradnja/artifacts/jttgtses_1.jpg", title: "Zamena crepa" },
        { url: "https://customer-assets.emergentagent.com/job_rade-gradnja/artifacts/047u5w9w_2.jpg", title: "Zamena crepa" }
      ]
    },
    {
      id: 'terasa-potkrovlje',
      title: 'Terasa sa ulazom za potkrovlje',
      coverImage: "https://images.unsplash.com/photo-1762608675427-09ac2dbd1540?crop=entropy&cs=srgb&fm=jpg&w=800&q=85",
      images: [
        { url: "https://customer-assets.emergentagent.com/job_rade-gradnja/artifacts/i16ajth6_1.jpg", title: "Terasa sa ulazom za potkrovlje" },
        { url: "https://customer-assets.emergentagent.com/job_rade-gradnja/artifacts/tto58o5d_2.jpg", title: "Terasa sa ulazom za potkrovlje" }
      ]
    }
  ];

  const openAlbum = (album) => {
    if (album.images.length === 0) return; // Don't open empty albums
    setSelectedAlbum(album);
    setCurrentImageIndex(0);
  };

  const closeAlbum = () => {
    setSelectedAlbum(null);
    setCurrentImageIndex(0);
  };

  const nextImage = (e) => {
    e.stopPropagation();
    if (selectedAlbum) {
      setCurrentImageIndex((prev) => 
        prev === selectedAlbum.images.length - 1 ? 0 : prev + 1
      );
    }
  };

  const prevImage = (e) => {
    e.stopPropagation();
    if (selectedAlbum) {
      setCurrentImageIndex((prev) => 
        prev === 0 ? selectedAlbum.images.length - 1 : prev - 1
      );
    }
  };

  return (
    <main className="pt-24" data-testid="gallery-page">
      {/* Hero Section */}
      <section className="bg-[#0B1E3B] py-20" data-testid="gallery-hero">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <span className="text-[#D4AF37] text-sm font-semibold tracking-widest uppercase mb-4 block">
            {t('gallery.tagline')}
          </span>
          <h1 className="text-5xl md:text-6xl font-bold text-white font-['Barlow_Condensed'] mb-4">
            {t('gallery.title')}
          </h1>
          <p className="text-gray-300 text-lg max-w-2xl mx-auto">
            {t('gallery.subtitle')}
          </p>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="bg-[#F8F9FA] py-12" data-testid="gallery-grid">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Section Title */}
          <h2 className="text-2xl font-semibold text-[#0B1E3B] mb-8 font-['Barlow_Condensed']">
            {language === 'sr' ? 'Naši radovi...' : 'Our work...'}
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {albums.map((album) => (
              <div 
                key={album.id}
                className={`group relative overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-all duration-300 bg-white ${album.images.length > 0 ? 'cursor-pointer' : 'cursor-default opacity-70'}`}
                onClick={() => openAlbum(album)}
                data-testid={`album-${album.id}`}
              >
                <div className="aspect-[4/3] overflow-hidden">
                  <img 
                    src={album.coverImage} 
                    alt={album.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-[#0B1E3B]/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-0 left-0 right-0 p-4">
                    <p className="text-white font-medium text-lg">{album.title}</p>
                    <p className="text-gray-300 text-sm">
                      {album.images.length === 0 
                        ? (language === 'sr' ? 'Uskoro...' : 'Coming soon...') 
                        : `${album.images.length} ${album.images.length === 1 ? (language === 'sr' ? 'slika' : 'photo') : (language === 'sr' ? 'slika' : 'photos')}`
                      }
                    </p>
                  </div>
                </div>
                {/* Always visible title */}
                <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-[#0B1E3B]/90 to-transparent group-hover:opacity-0 transition-opacity duration-300">
                  <p className="text-white font-medium">{album.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Album Lightbox */}
      {selectedAlbum && (
        <div 
          className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center"
          onClick={closeAlbum}
          data-testid="album-lightbox"
        >
          {/* Close button */}
          <Button
            variant="ghost"
            size="icon"
            className="absolute top-4 right-4 text-white hover:bg-white/20 z-10"
            onClick={closeAlbum}
            data-testid="lightbox-close"
          >
            <X className="h-8 w-8" />
          </Button>

          {/* Album title */}
          <div className="absolute top-4 left-4 text-white z-10">
            <h3 className="text-xl font-semibold">{selectedAlbum.title}</h3>
            <p className="text-gray-400 text-sm">
              {currentImageIndex + 1} / {selectedAlbum.images.length}
            </p>
          </div>

          {/* Navigation arrows */}
          {selectedAlbum.images.length > 1 && (
            <>
              <Button
                variant="ghost"
                size="icon"
                className="absolute left-4 top-1/2 -translate-y-1/2 text-white hover:bg-white/20 z-10"
                onClick={prevImage}
                data-testid="lightbox-prev"
              >
                <ChevronLeft className="h-10 w-10" />
              </Button>
              <Button
                variant="ghost"
                size="icon"
                className="absolute right-4 top-1/2 -translate-y-1/2 text-white hover:bg-white/20 z-10"
                onClick={nextImage}
                data-testid="lightbox-next"
              >
                <ChevronRight className="h-10 w-10" />
              </Button>
            </>
          )}

          {/* Current image */}
          <img 
            src={selectedAlbum.images[currentImageIndex].url} 
            alt={selectedAlbum.images[currentImageIndex].title}
            className="max-w-[90vw] max-h-[85vh] object-contain rounded-lg"
            onClick={(e) => e.stopPropagation()}
          />

          {/* Thumbnail navigation */}
          {selectedAlbum.images.length > 1 && (
            <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2 z-10">
              {selectedAlbum.images.map((img, index) => (
                <button
                  key={index}
                  onClick={(e) => {
                    e.stopPropagation();
                    setCurrentImageIndex(index);
                  }}
                  className={`w-16 h-12 rounded overflow-hidden border-2 transition-all ${
                    index === currentImageIndex ? 'border-[#D4AF37] opacity-100' : 'border-transparent opacity-60 hover:opacity-100'
                  }`}
                >
                  <img 
                    src={img.url} 
                    alt=""
                    className="w-full h-full object-cover"
                  />
                </button>
              ))}
            </div>
          )}
        </div>
      )}

      {/* CTA Section */}
      <section className="bg-white py-16" data-testid="gallery-cta">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-[#0B1E3B] font-['Barlow_Condensed'] mb-4">
            {t('contact.area.title')}
          </h2>
          <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
            {t('contact.area.description')}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="tel:+381631627662">
              <Button 
                size="lg"
                className="bg-[#0B1E3B] text-white hover:bg-[#0B1E3B]/90 font-semibold"
                data-testid="gallery-cta-phone"
              >
                <Phone className="mr-2 h-5 w-5" />
                +381 63 162 7662
              </Button>
            </a>
            <Link to="/kontakt">
              <Button 
                variant="outline" 
                size="lg"
                className="border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37] hover:text-[#0B1E3B] font-semibold"
                data-testid="gallery-cta-contact"
              >
                {t('hero.cta_contact')}
                <ArrowRight className="ml-2 h-5 w-5" />
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};
